import { component } from 'picoapp'
import Slider from '~/lib/slider'
import $ from 'quantdom'

export default component((node) => {
  const scrollTrack = $(node).find('[data-scroll-track]').el()
  let loaded = false
  let currentSlide = 1

  const slider = new Slider({ el: scrollTrack }, ({ isMin, isMax, index, filtering, slides, el }) => {
    if (loaded && currentSlide !== index && index !== 0) {
      currentSlide = index
      if (window?.gtag) {
        gtag('event', `PDP Carousel Viewed`, {
          event_detail: `${index}`,
        })
      }
    }
  })

  // wait for images to "complete"/load before unlocking scroll
  const unlockScroll = async () => {
    try {
      const selectedVariantId = $('#product-above-fold').find('[data-scroll-track]').attr('data-selected-variant-id')
      let variantImages = [
        $('#product-above-fold')
          .find(`[data-scroll-track] img.js-featured-image[data-variant-id='${selectedVariantId}']`)
          .el(),
      ]
      $('#product-above-fold')
        .find(`.js-variant-image[data-variant-id='${selectedVariantId}']`)
        .els.forEach((el) => {
          el.loading = 'eager'
          variantImages.push(el)
        })

      const completedImages = variantImages.filter((image) => image.complete)
      const loadingImages = variantImages
        .filter((image) => !image.complete)
        .map((image) => {
          return new Promise((resolve, reject) => {
            image.onload = () => resolve(image)
            image.onerror = () => reject(new Error(`Failed to load image: ${image.src}`))
          })
        })

      // Wait for all images to load
      const loadedImages = await Promise.allSettled(loadingImages)
      const successfullyLoadedImages = loadedImages
        .filter((result) => result.status === 'fulfilled')
        .map((result) => result.value)

      const allLoadedImages = [...completedImages, ...successfullyLoadedImages]

      $('#product-above-fold').find('[data-scroll-track]').addClass('tw-scroll-track')

      return allLoadedImages
    } catch (error) {
      console.error('Error loading product gallery images:', error)
      $('#product-above-fold').find('[data-scroll-track]').addClass('tw-scroll-track')
      return []
    }
  }

  window.MicroBus.on(`product:html-replaced`, (e) => {
    unlockScroll()
  })

  window.MicroBus.on(`variant:update-gallery`, (e) => {
    document.querySelector('#product-above-fold [data-scroll-track]').scrollLeft = 0
    unlockScroll()
  })

  $(window).on('load', (e) => {
    unlockScroll()
    loaded = true
  })
})
